// extracted by mini-css-extract-plugin
module.exports = {"signoff":"SignOff__signoff___25Nkp","icon":"SignOff__icon___2Zw3_"};